import { PublicKey } from "@solana/web3.js";
export const PROGRAM_ID = new PublicKey("orgdXvHVLkWgBYerptASkAwkZAE563CJUu717dMNx5f");
//# sourceMappingURL=constants.js.map